"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.scrollToDocumentTop = void 0;
/**
 * Scrolls to the top of the document
 */
const scrollToDocumentTop = () => {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
};
exports.scrollToDocumentTop = scrollToDocumentTop;
